/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { FaAngleLeft, FaAngleRight, FaFilter, FaEraser } from 'react-icons/fa';

import TitlePages from 'components/_base/TitlePages';
import SubHeader from 'components/SubHeader';
import { tabs, passos, compareString } from '../_constants';

import './styles.scss';

const Materiais = (props) => {
  let updateRascunho = props.updateRascunho;
  let model = props.model;
  let entities = props.entities;
  let renderErrors = props.renderErrors;
  let setActiveTab = props.setActiveTab;

  let tipoMateriais = entities.tipoMateriais || [];

  const [materiais, setMateriais] = useState([]);

  let errors = (model.errors || []).filter(
    (error) => error.passo === passos.passoMateriais.nro
  );
  model.solicitacoes = model.solicitacoes || [];

  const [solicitacoes, setSolicitacoes] = useState(model.solicitacoes);
  const updateSolicitacoes = () => {
    setSolicitacoes([...model.solicitacoes]);
  };

  const [nome, setNome] = useState('');

  const getAllMateriais = () => {
    return [].concat(
      ...tipoMateriais
        .filter(
          (tipoMaterial) =>
            tipoMaterial.sigla !== 'C' &&
            tipoMaterial.sigla !== 'MS' &&
            (!model.materialTipoSigla?.length ||
              tipoMaterial.sigla === model.materialTipoSigla)
        )
        .map((tipoMaterial) => tipoMaterial.materiaisComunicacao)
    );
  };

  useEffect(() => {
    setSolicitacoes(model.solicitacoes);
  }, [model]);

  useEffect(() => {
    setMateriais(getAllMateriais());
  }, [props.entities?.tipoMateriais]);

  const addRemoveItem = (event) => {
    if (event.target.checked) {
      let materiaisComunicacao = [].concat(
        ...tipoMateriais.map(
          (tipoMaterial) => tipoMaterial.materiaisComunicacao
        )
      );

      // if (model.pedidoDeCampanha == true) {
      //   materiaisComunicacao = entities.campanhaMateriais;
      // }

      const material = materiaisComunicacao.find(
        (obj) => obj.materialComunicacaoId === parseInt(event.target.value)
      );

      const solicitacao = {
        materialComunicacaoId: material.materialComunicacaoId,
        materialComunicacao: material,
      };

      model.solicitacoes.push(solicitacao);
      updateSolicitacoes();
    } else {
      const indexItem = solicitacoes.findIndex(
        (obj) => obj.materialComunicacaoId === parseInt(event.target.value)
      );
      model.solicitacoes.splice(indexItem, 1);
      updateSolicitacoes(solicitacoes);
    }
  };

  const filtrar = () => {
    let materiais = getAllMateriais();

    if (nome.length > 0)
      materiais = materiais.filter((material) =>
        compareString(material.materialComunicacaoNome, nome)
      );

    setMateriais([...materiais]);
  };

  const limpar = () => {
    setNome('');
    setMateriais(getAllMateriais());
  };

  const renderFiltro = () => {
    return (
      <>
        <div className="row mb-3 d-flex align-items-center ">
          <div className="col-md-2 nome-material text-right">Nome</div>
          <div className="col-md-5">
            <input
              type="text"
              className="form-control"
              value={nome}
              onChange={(event) => {
                setNome(event.target.value);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-10 offset-lg-2 d-flex justify-content-start">
            <button
              className="btn btn-primary btn-navigation mr-3  "
              onClick={() => {
                filtrar();
              }}
            >
              <span>
                <FaFilter size={18} />
              </span>
              <span>FILTRAR</span>
            </button>

            <button
              className="btn bg-white text-primary border border-primary btn-navigation"
              onClick={() => {
                limpar();
              }}
            >
              <span>
                <FaEraser size={22} />
              </span>
              <span>LIMPAR</span>
            </button>
          </div>
        </div>
        <hr />
      </>
    );
  };

  const renderMateriais = () => {
    if (!tipoMateriais.length) return null;

    return (
      <div className="div-cards">
        {materiais.map((material, index) => {
          return (
            <div key={index} className="card-material body-card-material">
              {/* <label>
                  <input type="radio" checked={material.materialComunicacaoId === 0} onChange={() => {
                    model.materialComunicacaoId = material.materialComunicacaoId;

                  }} />

                </label> */}

              <div className="lista-campanha-materiais">
                {/* <div
                  className={`header-card ${solicitacoes.findIndex(
                    (solicitacao) =>
                      solicitacao.materialComunicacaoId ===
                      material.materialComunicacaoId
                  ) !== -1
                      ? 'selecionado'
                      : ''
                    }`}
                >
                  {/* {
                      solicitacoes.findIndex((solicitacao) => solicitacao.materialComunicacaoId === material.materialComunicacaoId) !== -1 &&
                      <i className="icon-check">
                        <FaCheck size={16} />
                      </i>
                    } */}
                {/* {material.materialComunicacaoNome} */}
                {/* </div> } */}
                <div
                  className={`body-card ${
                    solicitacoes.findIndex(
                      (solicitacao) =>
                        solicitacao.materialComunicacaoId ===
                        material.materialComunicacaoId
                    ) !== -1
                      ? 'selecionado'
                      : ''
                  }`}
                >
                  <input
                    type="checkbox"
                    name=""
                    id={`check-material-${material.materialComunicacaoId}`}
                    value={material.materialComunicacaoId}
                    onChange={addRemoveItem}
                    checked={
                      solicitacoes.findIndex(
                        (solicitacao) =>
                          solicitacao.materialComunicacaoId ===
                          material.materialComunicacaoId
                      ) !== -1
                    }
                  />

                  <label
                    htmlFor={`check-material-${material.materialComunicacaoId}`}
                  >
                    <img
                      src={material.urlImagem}
                      className="img-fluidmax-width: 100% img-height:auto"
                    />
                  </label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="wrapper-content-pedido-materiais">
      <div className="content-pedido-materiais">
        <SubHeader title={model.loja?.razaoSocial} />

        <TitlePages title="Selecione os Materiais" />

        {renderErrors(errors)}

        {/* {renderFiltro()} */}
        <div className="materiais-content-campanha">{renderMateriais()}</div>
        <div className="row mt-5">
          <div className="col-lg-12 d-flex justify-content-between">
            <div className="text-left">
              <button
                className="btn btn-primary btn-navigation"
                onClick={() => {
                  updateRascunho();
                  setActiveTab(tabs.tabCliente);
                }}
              >
                <span>
                  <FaAngleLeft size={26} />
                </span>
                <span>VOLTAR</span>
              </button>
            </div>

            <div className="d-flex flex-row-reverse">
              <button
                className="btn btn-primary btn-navigation btn-navigation-right"
                onClick={() => {
                  updateRascunho(model);
                  setActiveTab(tabs.tabEntrega);
                }}
              >
                <span>AVANÇAR</span>
                <span>
                  <FaAngleRight size={26} />
                </span>
              </button>
            </div>

            {/* <pre className="text-left">{JSON.stringify(tipoMateriais, null, 2)}</pre> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Materiais;
